import React from "react";
import { useUpdatePortfolioCreationMutation } from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { Form, Formik } from "formik";
import * as Yup from "yup"
import SelectInput from "../../../Common/components/select-input";

const EditPortfolioCreationModal = ({ showEditPortfolioCreationModal, onHide, details, tableRef }) => {

    const [
        updatePortfolioCreation, // This is the mutation trigger
        {
            isLoading: isUpdating
        }, // This is the destructured mutation result
    ] = useUpdatePortfolioCreationMutation()

    /* Update Portfolio Creation */
    const onSubmit = (values) => {
        updatePortfolioCreation({
            id: details?.id,
            userId: details?.userId,
            ...values,
            meta: details
        })
            .unwrap()
            .then(() => {
                tableRef.current.refresh();
                cogoToast.success("Portfolio Creation Successfully Reset")
                onHide();
            });
    }

    return (
        <Modal
            show={showEditPortfolioCreationModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isUpdating ? "static" : true}
            keyboard={!isUpdating}
        >
            <Formik
                initialValues={{
                    paymentStatus: details?.paymentStatus,
                    accountFundStatus: details?.accountFundStatus,
                    status: details?.status,
                }}
                validationSchema={Yup.object({
                    paymentStatus: Yup.string().required("required"),
                    accountFundStatus: Yup.string().required("required"),
                    status: Yup.string().required("required")
                })}
                onSubmit={(values) => onSubmit(values)}
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Update Portfolio Creation
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <SelectInput
                                label="Payment Status*"
                                name="paymentStatus"
                                options={["PENDING", "COMPLETED", "FAILED"]}
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <SelectInput
                                label="Account Fund Status*"
                                name="accountFundStatus"
                                options={["PENDING", "COMPLETED", "FAILED"]}
                            />
                        </FormLayout.Row>
                        <FormLayout.Row>
                            <SelectInput
                                label="Status*"
                                name="status"
                                options={["PENDING", "COMPLETED", "FAILED"]}
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isUpdating}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isUpdating}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Update
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal>
    )
}

export default EditPortfolioCreationModal;
